import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';

const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
});

function getSteps() {
    return ['Choose Bus', 'Passenger information', 'Confirm information', 'Pay tickets', 'Ticket View'];
}

class BusSteppers extends React.Component {
    state = {
        activeStep: 0,
        completed: new Set(),
        skipped: new Set(),
    };

    isStepSkipped(step) {
        return this.state.skipped.has(step);
    }

    render() {
        const { classes } = this.props;
        const steps = getSteps();
        const { active } = this.props;
        return (
            <div className={classes.root}>
                <Stepper alternativeLabel nonLinear activeStep={active} >
                    {steps.map((label, index) => {
                        const props = {};
                        const buttonProps = {};

                        if (this.isStepSkipped(index)) {
                            props.completed = false;
                        }
                        return (
                            <Step key={label} {...props} completed={index < active ? true : false}  >
                                {index === active &&
                                    < StepButton
                                        // onClick={this.handleStep(index)}
                                        // completed={this.isStepComplete(index)}
                                        {...buttonProps}
                                        className='persent-step'
                                    >
                                        {label}
                                    </StepButton>
                                }
                                {index < active &&
                                    <StepButton
                                        // onClick={this.handleStep(index)}
                                        // completed={this.isStepComplete(index)}
                                        {...buttonProps}
                                        className="active-completed-steps"
                                    >
                                        {label}
                                    </StepButton>
                                }
                                {index > active &&
                                    <StepButton
                                        // onClick={this.handleStep(index)}
                                        // completed={this.isStepComplete(index)}
                                        {...buttonProps}
                                    // className="active-completed-steps"
                                    >
                                        {label}
                                    </StepButton>
                                }

                            </Step>
                        );
                    })}
                </Stepper>

            </div>
        );
    }
}

BusSteppers.propTypes = {
    classes: PropTypes.object,
};

export default withStyles(styles)(BusSteppers);


// WEBPACK FOOTER //
// ./src/containers/bus/busSteppers.jsx